module.exports = require("./bs-Latn");